import axios from "../../axios";
export default {
  namespaced: true,
  state: {
    table: [],
    drivers: [],
    daysInfo: [],
  },
  mutations: {
    SET_TABLE(state, products) {
      const drivers = products.map((el) => {
        return {
          label: `${el.driver_last_name} ${el.driver_name}`,
          value: el.driver_name,
        };
      });

      state.drivers = [
        ...new Map(drivers.map((item) => [item.label, item])).values(),
      ];
      state.table = products;
    },

    SET_DAYS_INFO(state, products) {
      return (state.daysInfo = products);
    },

    // SET_VEHICLES(state, products) {
    //   let vehicles = [];
    //   if (products) {
    //     vehicles = products.results.map((el) => {
    //       return {
    //         label: `${el.vehicle_id}`,
    //         value: el.vehicle_id,
    //       };
    //     });

    //     vehicles = vehicles.filter(
    //       (item, index, self) =>
    //         index === self.findIndex((t) => t.value === item.value)
    //     );
    //   } else return;

    //   return (state.vehicles = vehicles);
    // },
  },
  actions: {
    fetchTable({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/fmcsareports", {
            params,
          })
          .then((response) => {
            commit("SET_TABLE", response.data);
            resolve(response);
          })
          .catch((error) => {
            // console.log(error), reject(error);
          });
      });
    },
    fetchDays({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get("event/fmcsareports/dotoinspection", {
            params,
          })
          .then((response) => {
            commit("SET_DAYS_INFO", response.data);
            resolve(response);
          })
          .catch((error) => {
            // console.log(error), reject(error);
          });
      });
    },
    createReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        let query = "";

        for (let key in params) {
          query += `${encodeURIComponent(key)}=${encodeURIComponent(
            params[key]
          )}&`;
        }

        query = query.slice(0, -1);

        axios
          .post(`event/create-fmcsa-report?${query}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
